import { createSelector } from '@ngrx/store';
import { ingredientsState } from '../root';

export const isDownloadingAnyIngredientModifiers = createSelector(
    ingredientsState,
    (ingredients) => ingredients.some((obj) => obj.isDownloading)
);
